import React from "react";
import "./Footer.css";

const Footer = () => {
  return <footer />;
};

export default Footer;
